"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearChat = void 0;
const tslib_1 = require("tslib");
const ircv3_1 = require("ircv3");
/** @private */
let ClearChat = class ClearChat extends ircv3_1.Message {
    get date() {
        const timestamp = this._tags.get('tmi-sent-ts');
        return new Date(Number(timestamp));
    }
    get channelId() {
        return this._tags.get('room-id');
    }
    get targetUserId() {
        var _a;
        return (_a = this._tags.get('target-user-id')) !== null && _a !== void 0 ? _a : null;
    }
};
tslib_1.__decorate([
    (0, ircv3_1.MessageParamDefinition)({
        type: 'channel'
    })
], ClearChat.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, ircv3_1.MessageParamDefinition)({
        trailing: true,
        optional: true
    })
], ClearChat.prototype, "user", void 0);
ClearChat = tslib_1.__decorate([
    (0, ircv3_1.MessageType)('CLEARCHAT')
], ClearChat);
exports.ClearChat = ClearChat;
